const TECHNOPARKS = [
  "Abdullah Gül Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Adıyaman Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Adnan Menderes Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Afyon Uşak Zafer Teknoloji Geliştirme Bölgesi",
  "Aksaray Üniversitesi Teknoloji Geliştirme Bölgesi",
  "ALANYA TEKNOLOJİ GELİŞTİRME BÖLGESİ",
  "Altınbaş Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Amasya Teknoloji Geliştirme Bölgesi",
  "Ankara Bilim Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Ankara Teknoloji Geliştirme Bölgesi",
  "Ankara Teknopark Teknoloji Geliştirme Bölgesi",
  "Ankara Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Ankara Yıldırım Beyazıt Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Antalya Organize Sanayi Bölgesi Teknoloji Geliştirme Bölgesi",
  "ASBÜ Sosyal İnovasyon ve Girişimcilik Teknoloji Geliştirme Bölgesi",
  "ASO Teknopark Teknoloji Geliştirme Bölgesi",
  "Balıkesir Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Bandırma Onyedi Eylül Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Bartın Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Batı Akdeniz Teknokenti Teknoloji Geliştirme Bölgesi",
  "Batman Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Bilişim Vadisi Teknoloji Geliştirme Bölgesi",
  "Bingöl Teknoloji Geliştirme Bölgesi",
  "Biruni Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Boğaziçi Üniversitesi Kandilli Teknoloji Geliştirme Bölgesi",
  "Boğaziçi Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Bolu Teknoloji Geliştirme Bölgesi",
  "Bozok Teknoloji Geliştirme Bölgesi",
  "Bursa Teknik Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Celal Bayar Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Cumhuriyet Teknoloji Geliştirme Bölgesi",
  "Çanakkale Teknoloji Geliştirme Bölgesi",
  "Çankırı Teknoloji Geliştirme Bölgesi",
  "Çorum Teknoloji Geliştirme Bölgesi",
  "Çukurova Teknoloji Geliştirme Bölgesi",
  "Denizli OSB Teknoloji Geliştirme Bölgesi",
  "Dicle Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Dokuz Eylül Teknoloji Geliştirme Bölgesi",
  "Dudullu OSB Boğaziçi Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Düzce Teknopark Teknoloji Geliştirme Bölgesi",
  "Ege Teknopark Teknoloji Geliştirme Bölgesi",
  "Erciyes Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Erzurum Ata Teknokent Teknoloji Geliştirme Bölgesi",
  "Esenler Akıllı Şehir Odaklı İhtisas Teknoloji Geliştirme Bölgesi",
  "Eskişehir Teknoloji Geliştirme Bölgesi",
  "Fırat Teknoloji Geliştirme Bölgesi",
  "Gazi Teknopark Teknoloji Geliştirme Bölgesi",
  "Gaziantep OSB Teknoloji Geliştirme Bölgesi",
  "Gaziantep Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Gebze Teknik Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Giresun Teknoloji Geliştirme Bölgesi",
  "GOSB Teknopark Teknoloji Geliştirme Bölgesi",
  "Göller Bölgesi Teknoloji Geliştirme Bölgesi",
  "Hacettepe Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Harran Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Hatay Teknoloji Geliştirme Bölgesi",
  "Iğdır Üniversitesi Serhat Teknoloji Geliştirme Bölgesi",
  "İskenderun Teknik Üniversitesi Teknoloji Geliştirme Bölgesi",
  "İstanbul Finans ve Teknoloji Üssü Teknoloji Geliştirme Bölgesi",
  "İstanbul Medeniyet Üniversitesi Teknoloji Geliştirme Bölgesi",
  "İstanbul Sabahattin Zaim Üniversitesi Teknoloji Geliştirme Bölgesi",
  "İstanbul Teknik Üniversitesi Arı Teknokent Teknoloji Geliştirme Bölgesi",
  "İstanbul Teknoloji Geliştirme Bölgesi",
  "İstanbul Üniversitesi ve İstanbul Üniversitesi-Cerrahpaşa Teknoloji Geliştirme Bölgesi",
  "İTÜ Teknopark Teknoloji Geliştirme Bölgesi",
  "İzmir Bilim ve Teknoloji Parkı Teknoloji Geliştirme Bölgesi",
  "İzmir Teknoloji Geliştirme Bölgesi",
  "Kadir Has Üniversitesi Silivri Teknoloji Geliştirme Bölgesi",
  "Kahramanmaraş Teknoloji Geliştirme Bölgesi",
  "Kapadokya Teknoloji Geliştirme Bölgesi",
  "Karabük Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Karaman Teknoloji Geliştirme Bölgesi",
  "Kastamonu Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Kırıkkale Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Kırklareli Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Kırşehir Ahi Evran Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Kocaeli Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Konya Teknoloji Geliştirme Bölgesi",
  "Kuzey İzmir Teknoloji Geliştirme Bölgesi",
  "Kütahya Dumlupınar Tasarım Teknoloji Geliştirme Bölgesi",
  "Malatya Teknoloji Geliştirme Bölgesi",
  "Marmara Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Mehmet Akif Ersoy Üniversitesi MAKÜ BAKA Teknoloji Geliştirme Bölgesi",
  "Mersin Tarım ve Gıda İhtisas Teknoloji Geliştirme Bölgesi",
  "Mersin Teknoloji Geliştirme Bölgesi",
  "Muğla Sıtkı Koçman Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Namık Kemal Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Niğde Ömer Halisdemir Üniversitesi Teknoloji Geliştirme Bölgesi",
  "ODTÜ TEKNOKENT Teknoloji Geliştirme Bölgesi",
  "ODTÜ Uzay Teknolojileri Teknoloji Geliştirme Bölgesi",
  "Osmaniye Teknoloji Geliştirme Bölgesi",
  "Ostim Ekopark Teknoloji Geliştirme Bölgesi",
  "Pamukkale Üniversitesi Teknoloji Geliştirme Bölgesi",
  "POLSAN Teknoloji Geliştirme Bölgesi",
  "Recep Tayyip Erdoğan Üniversitesi ve Türk-Alman Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Sağlık Bilimleri Üniversitesi Teknoloji Geliştirme Bölgesi Sağlık Teknokenti",
  "Sakarya Uygulamalı Bilimler Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Sakarya Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Samsun Teknoloji Geliştirme Bölgesi",
  "Selçuk Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Sinop Teknoloji Geliştirme Bölgesi",
  "Sivas Bilim ve Teknoloji Üniversitesi Teknopark Teknoloji Geliştirme Bölgesi",
  "TEKNOGÜ Teknoloji Geliştirme Bölgesi",
  "TeknoHAB Teknoloji Geliştirme Bölgesi",
  "TOBB Ekonomi ve Teknoloji Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Tokat Teknoloji Geliştirme Bölgesi",
  "Trabzon Teknoloji Geliştirme Bölgesi",
  "Trakya Üniversitesi Edirne Teknoloji Geliştirme Bölgesi",
  "Tübitak-Marmara Araştırma Merkezi Teknopark Teknoloji Geliştirme Bölgesi",
  "Ulutek Teknoloji Geliştirme Bölgesi",
  "Yalova Teknoloji Geliştirme Bölgesi",
  "Yıldız Teknik Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Yüzüncü Yıl Üniversitesi Teknoloji Geliştirme Bölgesi",
  "Zonguldak Teknoloji Geliştirme Bölgesi"
];

export default TECHNOPARKS;
